module.exports = __webpack_public_path__ + "img/item8.bedeb469.png";